import { handleEnableChat } from '@amzn/rangoli-seller-desktop-utils/src/constants/Footer';
import { redirectionUrls } from './apiConstants';

export const footerConstantData = {
  TermsAndConditionText: 'Terms of Use',
  privacyPolicyText: 'Privacy Policy',
  getSupport: 'Get Support',
  yearAndLogoText: '© 2023 - 2024 Amazon Smartbiz',
};
export const footerData = [
  {
    name: footerConstantData.TermsAndConditionText,
    link: redirectionUrls.termsAndConditionUrl,
  },
  {
    name: footerConstantData.privacyPolicyText,
    link: redirectionUrls.privacyPolicyUrl,
  },
  {
    name: footerConstantData.getSupport,
    onclick: handleEnableChat,
  },
];